module.exports = __webpack_public_path__ + "img/coca-cola_hellenic.c39af57b.png";